import React from 'react';
import { Scale } from 'lucide-react';
import { Heading } from '../../../ui/heading';

const PageHeader: React.FC = () => {
  return (
    <div className="bg-card border-b border-border px-6 py-6">
      <div>
        <Heading level={1} weight="bold" className="text-foreground flex items-center gap-2">
          <Scale className="w-7 h-7 text-primary" />
          Ombudsman Simulator
        </Heading>
      </div>
    </div>
  );
};

export default PageHeader;
